import { Component, OnInit } from '@angular/core';
import {AgendaService} from "../shared/model/agenda.service";
import {Observable} from "rxjs";
import {AgendaItem} from "../shared/model/agendaItem";
import {AuthService} from "../shared/security/auth.service";
import {TranslateService} from "@ngx-translate/core";
import {CommandService} from "../shared/model/command.service";
import {TenantService} from "../shared/model/tenant.service";
import {Court} from "../shared/model/court";


@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css']
})
export class AgendaComponent implements OnInit {
  agendaItems: Observable<AgendaItem[]>;
  clubIdForUser: string;
  tenantIdForUser: number;
  day: number = -1;
  rowIndex: number = 0;
  courts: Court[] = [];
  currentCourt: Court = null;
  currentAgendaItem: AgendaItem = null;

  showError: boolean = false;
  showAddAgenda: boolean = false;
  showUpdateAgenda: boolean = false;

  constructor(private authService: AuthService, private agendaService: AgendaService, private translateService: TranslateService, private commandService: CommandService, private tenantService: TenantService) {

  }

  ngOnInit() {
    this.clubIdForUser = this.authService.getClubIdForUser();
    this.tenantIdForUser = this.authService.getTenantIdForUser();
    this.day = -1;
    this.agendaItems = this.agendaService.findAgendaItemsForTenant();
    this.tenantService.getCourts(this.tenantIdForUser, this.clubIdForUser).then( cts => {
      this.courts = cts;
      //console.log(cts);
    });
  }

  public showModalAgendaWindow( show: boolean ) {
    //console.log(`showModalAgendaWindow is ${show}`);
    this.showAddAgenda = show;
  }

  public showModalUpdateAgendaWindow( show: boolean ) {
    //console.log(`showModalUpdateAgendaWindow is ${show}`);
    this.showUpdateAgenda = show;
  }

  onOrOff( type: string ): string {
    if ( type === 'normal' ) {
      return 'l.on';
    } else if ( type === 'off' ) {
      return 'l.off';
    } else {
      return 'l.on';
    }
  }

  deleteAgendaItem( item: AgendaItem ) {
    let c = {};

    if ( item.hasOwnProperty('tenantId' ) ) {
      c['tenantId'] = item.tenantId;
    } else if ( item.hasOwnProperty('clubId' ) ) {
      c['clubId'] = item.clubId;
    } else {
      return; // missing parameter
    }

    if ( item.hasOwnProperty('day') && item.hasOwnProperty( 'index' ) ) {
      c['day'] = item.day;
      c['index'] = item.index;
    } else {
      return; // missing parameter
    }

    c['request'] = 'DB_DELETE_AGENDA_ITEM';

    //console.log(c);
    this.commandService.sendCommand(c);
  }

  updateAgendaItem( item: AgendaItem ) {
    //console.log('updateAgendaItem');
    //console.log(item);
    this.currentAgendaItem = item;
    this.day = item.day;
    this.showModalUpdateAgendaWindow(true);
  }

  dayOfTheWeek( dayNr: number ) : string {
    return "l.day" + dayNr;
  }

  selectDay(day: number) {
    this.agendaItems = this.agendaService.findAgendaItemsForTenantAndDay(day);
  }

  selectAllDays() {
    this.agendaItems = this.agendaService.findAgendaItemsForTenant();
  }

  switchDay( day: number ): boolean {
    let oldDay = this.day;
    this.day = day;
    if ( day === oldDay ) {
      return false;
    } else {
      return true;
    }
  }

  incrementRowIndex() {
    this.rowIndex++;
  }

  getRowIndex(): number {
    return this.rowIndex;
  }

  resetRowIndex(): void {
    this.rowIndex = 0;
  }

  closeError(val: boolean) {
    this.showError = false;
  }

  selectDetail( court: number ) {
    //console.log(`court: ${court}`);
    //console.log(this.courts);
    //console.log(`courts length: ${this.courts.length}`);
    for ( let i = 0; i < this.courts.length; i++ ) {
      if ( this.courts[i]['court'] === court ) {
        //console.log( this.courts[i] );
        this.currentCourt = this.courts[i];
      }
    }
    this.showError = true;
  }

}
